<template>
  <v-layout column>
    <div>
      <v-row no-gutters>
        <v-col
          :cols="6"
          :md="6"
          :sm="12"
        >
          <div class="login-box">
            <div class="login-form">
              <img src="../../../assets/everli_logo@1x.png">
              <h4 class="text-h5">
                {{ $t('login.retailer_dashboard') }}
              </h4>

              <v-form
                ref="form"
                @submit.prevent.native="onSubmit"
              >
                <v-text-field
                  v-model="form.email"
                  name="email"
                  :error-messages="errors.email"
                  label="Email"
                  required
                />

                <v-text-field
                  v-model="form.password"
                  name="password"
                  :error-messages="errors.password"
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('login.password')"
                  required
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                />

                <div
                  v-if="errorMessage"
                  class="response-error error--text"
                >
                  {{ errorMessage }}
                </div>

                <v-btn
                  type="submit"
                  :loading="isLoading"
                  color="primary"
                  class="mt-8"
                  large
                >
                  {{ $t('login.sign_in') }}
                </v-btn>
              </v-form>
            </div>
          </div>
        </v-col>

        <v-col
          :cols="6"
          :md="6"
          :sm="0"
          class="login-bg"
        />
      </v-row>
    </div>
  </v-layout>
</template>

<script>
import config from '@/config'
import Api from '@/helpers/api'

export default {
  data () {
    return {
      isLoading: false,
      form: {
        email: '',
        password: ''
      },
      errors: {},
      errorMessage: '',
      showPassword: false
    }
  },

  methods: {
    onSubmit () {
      this.isLoading = true
      this.errors = {}
      this.errorMessage = ''

      this.$store
        .dispatch('auth/login', this.form)
        .then((responseData) => {
          // change locale
          this.setLocale(responseData.language || config.app_default_locale)

          // redirect after success
          // we're opening next page with window.location.href so main.js could be loaded again and inject store_ref_id into vue-gtag lib
          const redirect = this.$route.query.redirect
          const { href } = this.$router.resolve({ path: (typeof redirect !== 'undefined' ? redirect : '/orders') })
          window.location.href = href
        })
        .catch(error => {
          const response = Api.getValidationErrors(error)
          this.errors = response.errors

          // Show error message only if there are no errors in form fields
          if (!Object.keys(response.errors).length){
            this.errorMessage = response.message
          }
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  .login-form {
    text-align: center;
    padding: 70px;
    width: 480px;
    height: 530px;
    background: #fff;
    border-radius: 40px;

    img {
      margin: 0 auto 10px;
    }

    h4 {
      margin-bottom: 30px;
    }

    form {
      display: flex;
      flex-direction: column;
    }

    .response-error {
      margin-top: 20px;
    }
  }
}

.login-bg {
  position: fixed;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  background-image: url('./../../../assets/login-bg.jpg');
  background-size: cover;
  background-position: right center;
}
</style>
